import {Injectable} from '@angular/core';
import {Resolve, ActivatedRouteSnapshot, Router} from '@angular/router';
import {Observable, of} from 'rxjs';
import {catchError, map} from 'rxjs/operators';
import {UiBlockerService} from '@app/services/ui-blocker.service';
import {UtilService} from '@app/services/util.service';
import {GeneralSetting} from '../models/general-setting.model';
import {GeneralSettingService} from '../services/general-setting.service';

@Injectable({providedIn: 'root'})
export class GeneralSettingResolver implements Resolve<GeneralSetting> {

    constructor(private service: GeneralSettingService,
                private uiBlockerService: UiBlockerService,
                private utilService: UtilService,
                private router: Router) {
    }

    resolve(route: ActivatedRouteSnapshot): Observable<GeneralSetting> {
        this.uiBlockerService.block();
        const projectId = +this.utilService.getRouteParameter(route, 'projectId');
        const modelRunId = this.utilService.getRouteParameter(route, 'modelRunId');
        return this.service.get(projectId, modelRunId).pipe(map((generalSetting: GeneralSetting) => {
            this.uiBlockerService.unblock();
            return generalSetting;
        }), catchError(() => {
            this.uiBlockerService.unblock();
            this.router.navigate(['/404']);
            return of(null);
        }));
    }
}
